import { render, staticRenderFns } from "./PatientAdd.vue?vue&type=template&id=f11a36fc&scoped=true"
import script from "./PatientAdd.vue?vue&type=script&lang=js"
export * from "./PatientAdd.vue?vue&type=script&lang=js"
import style0 from "./PatientAdd.vue?vue&type=style&index=0&id=f11a36fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11a36fc",
  null
  
)

export default component.exports